import script from "./no-nav.vue?vue&type=script&setup=true&lang=js"
export * from "./no-nav.vue?vue&type=script&setup=true&lang=js"

import "./no-nav.vue?vue&type=style&index=0&id=479871aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-479871aa"]])

export default __exports__